import counts from './counts';
import moreRequestData from './moreRequestData';

const root = {
	counts,
	moreRequestData
};

export default root;
